import Generator from '../../../Generator'
import Types from '../../../../actions/Types'

export default Generator.node({
  baseType: Types.BATTERIES,
  nodeType: Generator.NODETYPE.PUT
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/batteries/put.js